/**
 * moment配置文件
 *
 * @date 2019-05-22
 * @author chenyongzheng
 */

// 引入vue
import Vue from 'vue';

// 引入moment
import moment from 'moment';

// 挂载到 Vue原型链
Vue.prototype.$moment = moment;



// WEBPACK FOOTER //
// ./src/utils/moment.js